module.exports = __webpack_public_path__ + "components/weather-icon/static/nightlightsnow-743a69006b2314c969a91269378960a1.png";